/* assets/label-upload-image.js
   Upload image feature for Label Maker.
   Important: uploaded image is stored as a data URL, not blob:, so exported SVG is self-contained.
*/
;(function () {
  let uploadedImageUrl = null

  function setImageHref(svgImage, url) {
    if (!svgImage || !url) return
    svgImage.setAttribute('href', url)
    svgImage.setAttribute('xlink:href', url)
  }

  function applyUploadedImage() {
    if (!uploadedImageUrl) return
    const host = document.getElementById('imported-Label')
    if (!host) return
    const svgImage = host.querySelector('image#ImagePlaceHolder') || host.querySelector('image')
    setImageHref(svgImage, uploadedImageUrl)
  }

  const host = document.getElementById('imported-Label')
  if (host) {
    const observer = new MutationObserver(applyUploadedImage)
    observer.observe(host, { childList: true, subtree: true })
  }

  const fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.accept = 'image/*'
  fileInput.style.display = 'none'
  document.body.appendChild(fileInput)

  fileInput.addEventListener('change', e => {
    const file = e.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      uploadedImageUrl = String(reader.result || '')
      window.labelMakerUploadedImageDataUrl = uploadedImageUrl
      applyUploadedImage()
      fileInput.value = ''
    }
    reader.onerror = () => {
      console.error('[label-upload-image] Could not read uploaded image')
      fileInput.value = ''
    }
    reader.readAsDataURL(file)
  })

  document.addEventListener('click', e => {
    const textEl = e.target.closest('text')
    if (!textEl) return
    const content = textEl.textContent.replace(/\s+/g, ' ').trim()
    if (content === 'Have better image? Use it!') fileInput.click()
  }, { passive: true })
})()
